export default __webpack_public_path__ + "static/media/doopage_logo_gray.1b03c218.svg";